import * as OvationsApi from 'core/ovations-api';
import { range } from 'lodash';

export const mockReports: OvationsApi.Types.Report[] = range(1, 7).map((i) => ({
    id: `__id-${i}__`,
    name: `__report-${i}__`,
    allowedRoleIds: range(1, i).map((j) => `__role-id-${j}__`),
}));

export const mockReport = mockReports[0];
